import { render, staticRenderFns } from "./OrganizationSelector.vue?vue&type=template&id=684a7ba2&"
import script from "./OrganizationSelector.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSelector.vue?vue&type=style&index=0&id=684a7ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports